module.exports = __webpack_public_path__ + "static/CARD@3x-ffaa90724b4345947f6564f3361265c4.png";